export function handleSpecsTabs() {
  const tabs = [...document.querySelectorAll('.c-tab')]
  const specsImages = [...document.querySelectorAll('.c-specs__image')]
  const specsObjectArray = []
  tabs.forEach((element, index) => {
    const spec = {
      index,
      image: specsImages[index],
      tab: tabs[index],
    }
    specsObjectArray.push(spec)
  })

  specsObjectArray.forEach((spec) => {
    spec.tab.addEventListener('click', (e) => {
      e.preventDefault()
      specsObjectArray.forEach((specObject) => {
        if (specObject.tab === spec.tab) {
          specObject.tab.classList.add('u-js-is-active-tab')

          specObject.image.classList.remove('u-is-hidden')
        } else {
          specObject.tab.classList.remove('u-js-is-active-tab')

          specObject.image.classList.add('u-is-hidden')
        }
      })
    })
  })
}

export function handleSpecsTabs2() {
  const tabs = [...document.querySelectorAll('.c-tab-2')]
  const specsImages = [...document.querySelectorAll('.c-specs__image')]
  const specsObjectArray = []
  tabs.forEach((element, index) => {
    const spec = {
      index,
      image: specsImages[index],
      tab: tabs[index],
    }
    specsObjectArray.push(spec)
  })

  specsObjectArray.forEach((spec) => {
    spec.tab.addEventListener('click', (e) => {
      e.preventDefault()
      specsObjectArray.forEach((specObject) => {
        if (specObject.tab === spec.tab) {
          specObject.tab.classList.add('u-js-is-active-tab-2')

          specObject.image.classList.remove('u-is-hidden')
        } else {
          specObject.tab.classList.remove('u-js-is-active-tab-2')

          specObject.image.classList.add('u-is-hidden')
        }
      })
    })
  })
}
